import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Header from './components/Header';
import HojaPage from './pages/HojaPage';
import DictionaryPage from './pages/DictionaryPage';
import YasnaDictionaryPage from './pages/YasnaDictionaryPage';
import AnnotatePage from './pages/AnnotatePage';
import AboutPage from './pages/AboutPage';
import SettingsPage from './pages/SettingsPage';
import RequireAnnotator from './components/RequireAnnotator';
import { UserPreferencesProvider } from './context/UserPreferencesContext';
import { AuthProvider } from './context/AuthContext';

import './App.css';

// Learner pages (watch, dictionary, settings) are public. Pages that write
// to Firestore need a signed-in annotator — see context/AuthContext.js and
// firestore.rules, which enforces the same split server-side.
function App() {
  return (
    <Router>
      <AuthProvider>
        <UserPreferencesProvider>
          <div className="app">
            <Header />
            <main className="app-main">
              <Routes>
                <Route path="/about" element={<AboutPage />} />
                <Route path="/" element={<HojaPage />} />
                <Route path="/dictionary" element={<YasnaDictionaryPage />} />
                {/* hoja's pre-yasna dictionary editor, until its entries are migrated */}
                <Route
                  path="/dictionary/legacy"
                  element={<RequireAnnotator><DictionaryPage /></RequireAnnotator>}
                />
                <Route
                  path="/annotate"
                  element={<RequireAnnotator><AnnotatePage /></RequireAnnotator>}
                />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
          </div>
        </UserPreferencesProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
